import AbstractWrapperElement from '../wrappers/AbstractWrapperElement';
import IframeService from './abstract/IframeService';

interface IWrapperElementSyncData {
  element: AbstractWrapperElement;
}

class WrapperSynchronizer extends IframeService {
  private iframeRef: HTMLIFrameElement;

  constructor() {
    super('WrapperSynchronizer');
  }

  public injectIframe(iframe: HTMLIFrameElement): void {
    this.iframeRef = iframe;
  }

  private elements: Map<
    string,
    IWrapperElementSyncData | IWrapperElementSyncData[]
  > = new Map();

  registerElement(elementData: IWrapperElementSyncData, elementId) {
    if (this.elements.has(elementId)) {
      const elements = this.elements.get(elementId);
      if (Array.isArray(elements)) {
        elements.push(elementData);
      } else {
        this.elements.set(elementId, [elements, elementData]);
      }

      return;
    }

    this.elements.set(elementId, elementData);
  }

  unregisterElement(elementId) {
    this.elements.delete(elementId);
  }

  updateElementsPosition(id, elementPosition) {
    let iframePosition = this.iframeRef.getBoundingClientRect();

    if (this.elements.has(id)) {
      const elements = this.elements.get(id);
      if (Array.isArray(elements)) {
        elements.forEach((element) => {
          element.element.updateElementPosition(
            elementPosition,
            iframePosition
          );
        });
      } else {
        elements.element.updateElementPosition(elementPosition, iframePosition);
      }
    }
  }
}

export default WrapperSynchronizer;
